import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAccounts, selectOrganization } from './multi-account.thunks';

interface Account {
  id: string;
  name: string;
  logo: string;
  user_id: string;
}

interface MultiAccountState {
  accounts: Account[];
  loading: boolean;
  error: boolean;
  selectingAccount: boolean;
}

const initialState: MultiAccountState = {
  accounts: [],
  loading: false,
  error: false,
  selectingAccount: false,
};

const multiAccountSlice = createSlice({
  name: 'multiAccount',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = false;
    },
    resetState: (state) => {
      state.accounts = [];
      state.loading = false;
      state.error = false;
      state.selectingAccount = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchAccounts.fulfilled, (state, action: PayloadAction<Account[]>) => {
        state.loading = false;
        state.accounts = action.payload;
        state.error = false;
      })
      .addCase(fetchAccounts.rejected, (state) => {
        state.loading = false;
        state.error = true;
        state.accounts = [];
      })
      // Select organization
      .addCase(selectOrganization.pending, (state) => {
        state.selectingAccount = true;
        state.error = false;
      })
      .addCase(selectOrganization.fulfilled, (state) => {
        state.selectingAccount = false;
        state.error = false;
      })
      .addCase(selectOrganization.rejected, (state) => {
        state.selectingAccount = false;
        state.error = true;
      });
  },
});

export const { resetError, resetState } = multiAccountSlice.actions;
export default multiAccountSlice.reducer;
